<template>
	<Select
		v-model:value="contactId"
		:canBeCleared="true"
		:options="contacts"
		:searchEnabled="true"
		errorName="belongs_id"
		label="Contact"
		placeholder="Select contact"
		searchPlaceholder="Search contacts"
		valueKey="id"
		@clear="
			() => {
				contactId = null;
				dealId = null;
				deals = [];
			}
		"
		@menuOpened="getContacts"
		@searchKeyup="getContacts"
		@update:value="getDeals(contactId)"
	>
		<template #option="{ option, selected }">
			<div class="flex">
				<!--				<div class="w-6 h-6 bg-red-600/20 mr-2 rounded-full flex items-center justify-center shrink-0 text-[9px] font-semibold shrink-0 text-center">-->
				<!--					{{ selected ? contact.initals() : option.initals() }}-->
				<!--				</div>-->

				<div class="text-15 font-normal">
					{{ selected ? contact.fullName() : option.fullName() }}
				</div>
			</div>
		</template>
	</Select>

	<Select
		v-if="canAddToDeal"
		v-model:value="dealId"
		:canBeCleared="true"
		:disabled="contacts.length == 0 || deals.length == 0"
		:options="deals"
		:placeholder="dealPlaceholder"
		class="mt-4"
		label="Deal"
		valueKey="id"
	>
		<template #option="{ option }">
			<div class="flex items-center">
				<div
					:class="[option.getStatusColour()]"
					class="w-2 h-2 mr-2 rounded-full shrink-0"
				/>
				<div class="text-15 font-normal">
					{{ option.getName() }} - {{ $help.dp(option.quoted, 0) }}
				</div>
			</div>
		</template>
	</Select>

	<input :value="belongs.type" name="belongs_type" type="hidden" />
	<input :value="belongs.id" name="belongs_id" type="hidden" />
	<!-- <input type='hidden' name='pinned' :value='pinned ? 1 : 0' /> -->
</template>

<script>
import Deal from "~/models/deal.js";
import Contact from "~/models/contact.js";

export default {
	props: {
		defaultBelongsId: { type: Number, default: null },
		defaultBelongsType: { type: Number, default: null },
		canAddToDeal: { type: Boolean, default: true },
		modelId: { type: [Number], default: null },
		modelType: { type: [Number, String], default: null },
	},

	data() {
		return {
			contactId: null,
			dealId: null,
			contact: null,
			contacts: [],
			deals: [],
		};
	},

	created() {
		this.getContacts().then((res) => {
			if (this.defaultBelongsType == 103) {
				this.dealId = this.defaultBelongsId;
				// this.deal
			}

			if (this.defaultBelongsType == 102) {
				this.contactId = this.defaultBelongsId;
				this.contact = this.contacts.find(
					(c) => c.id == this.defaultBelongsId,
				);
			}
		});
	},

	methods: {
		getContacts(event = "") {
			return Promise.resolve(
				this.$axios
					.get("/actions/contacts-search", {
						params: {
							search: event,
						},
					})
					.then((res) => {
						// this.contactId = null
						// this.dealId = null
						this.contacts = Contact.fill(res.contacts, {
							vue: this,
						});
					}),
			);
		},

		getDeals(contactId) {
			if (contactId == undefined || typeof contactId != "number") {
				return;
			}

			this.contact = this.contacts.find((c) => c.id == contactId);

			return Promise.resolve(
				this.$axios
					.get("/actions/contact-deals/" + contactId)
					.then((res) => {
						this.deals = Deal.fill(res.deals, {
							vue: this,
						});
					}),
			);
		},
	},

	computed: {
		belongs() {
			if (this.dealId != null) {
				return {
					id: this.dealId,
					type: 103,
				};
			}

			return {
				id: this.contactId,
				type: 102,
			};
		},

		dealPlaceholder() {
			if (this.contactId == null) {
				return "Select a contact first";
			}

			if (this.contactId != null && this.deals.length == 0) {
				let contact = this.contacts.find((c) => c.id == this.contactId);
				return contact.fullName() + " has no deals";
			}

			return "Assign deal (optional)";
		},
	},
};
</script>
